import { NetworkStatus } from '@cbridge-utils/network';
import { ISymbolAssetsStore } from './symbolAssets.interface';

export const symbolAssetsInitialState: ISymbolAssetsStore = {
  list: [],
  networkStatus: NetworkStatus.None,
};
